import FORMS_OF_PAYMENT from '../../scripts/constants/forms-of-payment';
import CARD_TYPES from '../../scripts/constants/card-types-enum';

class EMDVoucherFormOfPaymentUIModel {
  constructor({
    cardType = undefined,
  }) {
    this.class = FORMS_OF_PAYMENT.EMD_VOUCHER;
    this.cardType = cardType === undefined ? CARD_TYPES.EMD_VOUCHER : CARD_TYPES[cardType];
  }
}

export default EMDVoucherFormOfPaymentUIModel;
